import React from 'react';
import { IPublicPricing } from '../../services/pricing_public/pricing_public';
import { money } from './earnings';
import { StepItem, StepList } from './StepList.component';

// #region ArtistPathPanel
/** The Artist side panel: how licensing pays, and the steps to a first payout. */
export const ArtistPathPanel: React.FunctionComponent<{ pricing: IPublicPricing; steps: StepItem[]; columns: string }> = ({ pricing, steps, columns }): React.ReactElement => {
    const fee = pricing.licensing_fee;
    const exempt = pricing.royalty_exempt_panel_heights_ft.join(', ').replace(/, (\d+)$/, ' or $1');
    const facts: [string, string][] = [
        ['Your price', 'A percentage of each order, or a flat monthly or yearly fee. You choose per design.'],
        ['Wallmates fee', fee.type === 'PERCENTAGE' ? `${fee.value}% of what you earn` : `${money(fee.value)} per payout`],
        ['Paid', 'Monthly, straight to your Stripe account. No minimum.'],
        ['Free to try', `Brands can order samples and single ${exempt} ft panels without paying a royalty.`]
    ];
    return (
        <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-brand">For artists</p>
            <h3 className="mt-1 font-display text-2xl font-semibold tracking-tight text-black dark:text-white">How licensing pays you</h3>
            <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-400">
                Brands add your design to their own stores. Every time one sells, you earn, and you keep ownership of your work.
            </p>
            <div className={`mt-5 grid gap-x-10 gap-y-5 ${columns}`}>
                <dl className="space-y-3 text-sm">
                    {facts.map(([term, detail]) => (
                        <div key={term} className="rounded-xl bg-seabreeze/30 px-4 py-3 dark:bg-seabreeze/10">
                            <dt className="font-semibold text-zinc-900 dark:text-zinc-100">{term}</dt>
                            <dd className="mt-0.5 text-zinc-600 dark:text-zinc-400">{detail}</dd>
                        </div>
                    ))}
                </dl>
                <div>
                    <p className="mb-3 text-sm font-semibold text-zinc-900 dark:text-zinc-100">Get to your first payout</p>
                    <StepList steps={steps} />
                </div>
            </div>
        </div>
    );
};
